const dev = false;
export default {
  // host: 'http://zk.qihe.live',
  host: dev ? 'http://zk.qihe.local' : 'https://zk.qihe.live',
  appId: 'wxfe1b00e63efb55e6',
  token: null,
  info: null,
  auth: false,
  mc: false, //是否必须完善资料
  dev
}
